import React from 'react'
import { Link } from 'react-router-dom'
// import Header from '../../Components/Header/Header'
import Costeffective from '../PrintDesign/Costeffective'
import './ConceptCreation.css'
import FAQ from '../../Components/Faqs/Faqs'
import PriceCard from '../../Components/PriceCard/PriceCard'
import ContactUs from '../../Components/ContactCard/ContactCard'
// import Footer from '../../Components/Footer/Footer'
function ConceptCretion() {
  return (
    <div>
        {/* <Header/> */}
        <section className="Concept-hero d-flex align-items-center">
      <div className="container ">
       
          {/* Text Section */}
          <div className="col-lg-5 text-section ">
            <h1 className="hero-title">Concept Creation</h1>
            <p className="hero-description">
            Spark creativity with our concept creation services. We collaborate with you to develop innovative design concepts that align with your brand vision and goals. Our team brings fresh ideas to the table, helping you stand out in a competitive market and achieve your creative objectives.
            </p>
            <div className="hero-buttons">
              <button className="btn btn-blue me-3">Contact us</button>
            </div>
          </div>
      </div>
    </section>

    {/* Concept Creation workflow  design workflow */}
    <div className="design-workflow-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Section */}
          <div className="col-md-6">
            <h6 className="subheading">Innovative and Original</h6>
            <h2 className="title">Bringing Your Ideas to Life</h2>
          </div>
          {/* Right Section */}
          <div className="col-md-6">
            <p className="description">
            Concept creation is the foundation of any successful design project. This service involves brainstorming and developing innovative ideas that align with your brand’s vision and objectives. Strong concepts are crucial for guiding the design process and ensuring that the final product is both creative and strategically sound, setting the stage for compelling and effective visual communication.
            </p>
          </div>
        </div>
      </div>
    </div>

    
     {/* Concept creation and admin assistant service */}
     <div className="assistance-services-section">
      <div className="container">
        <h2 className="section-title text-center">Concept Creation Creative Services</h2>
        <div className="row text-center mt-5">
          {/* Service Card 1 */}
          <div className="col-md-4">
            <div className="service-card">
              <div >
                <img src="/images/Branding.webp" className="graphic-placeholder" alt="" />
              </div>
              <h5 className="service-title mt-3">Branding Concepts</h5>
              <p className="service-description">
              Develop unique branding concepts that capture the essence of your brand and resonate with your target audience. Strong branding concepts lay the foundation for all your visual communications.
              </p>
            </div>
          </div>

          {/* Service Card 2 */}
          <div className="col-md-4">
            <div className="service-card">
              <div >
                <img src="/images/idea.webp" alt="" className="graphic-placeholder" />
              </div>
              <h5 className="service-title mt-3">Campaign Ideas</h5>
              <p className="service-description">
              Brainstorm and create innovative campaign ideas that align with your marketing goals and engage your audience. Creative campaign concepts can drive awareness and generate excitement for your brand.
              </p>
            </div>
          </div>

          {/* Service Card 3 */}
          <div className="col-md-4">
            <div className="service-card">
              <div >
                <img src="/images/mood.webp" alt="" className="graphic-placeholder" />
              </div>
              <h5 className="service-title mt-3">Mood Boards &
              Concept Ideation</h5>
              <p className="service-description">
              Create mood boards and concept ideation pieces that visualise the overall feel and direction of your project. This helps in aligning the creative vision and provides a tangible reference for design elements, ensuring cohesive and effective visual communication.
              </p>
            </div>
          </div>
        </div>

        {/* Button */}
        <div className="text-center mt-4">
        <Link to={'/ourwork'}><button className="btn btn-outline-primary">
        View More Services
              </button></Link>
        </div>
      </div>
    </div>

    <Costeffective/>
    <div className="text-center mt-4">
      <a href="https://calendly.com/nida-ideal/call-with-media-dunes">  <button className="btn btn-blue primary">Book a Demo Call</button></a>
        </div>   


        {/* Concept-Creation-assisatance-service-para */}
<div className="assistance-service-container d-flex justify-content-center align-items-center">
      <div className="assistance-service-card p-4 ">
        {/* <h5 className="text-uppercase text-light mb-3">Why Media Dunes</h5> */}
        <h2 className="text-white mb-3">
        Why Media Dunes?
        </h2>
        <p className="text-light">
        Media Dunes sets itself apart with our Digital Ad Design service, offering personalized attention, deep brand understanding, and a smooth collaborative process. Our dedicated design team works closely with you to ensure each ad resonates with your brand’s voice and goals. Our user-friendly platform streamlines design requests, guaranteeing quick turnaround times and exceptional quality. Unlike other services, we provide unlimited design revisions, ensuring your complete satisfaction. With Media Dunes, you’ll receive customized, impactful, and captivating digital ads that deliver results.
        </p>
      </div>
    </div>

    <FAQ/>

    {/* Printdesign workflow  design workflow */}
 <div className="design-workflow-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Section */}
          <div className="col-md-6">
            <h6 className="subheading">Other services</h6>
            <h3 className="title">All your graphic design requirements all in one place</h3>
          </div>
          {/* Right Section */}
          <div className="col-md-6">
            <p className="description">
            At Hatchly, we offer a comprehensive suite of graphic design services tailored to meet all your creative needs. From eye-catching social media graphics and professional presentation designs to custom illustrations and impactful digital ads, our team of expert designers are here to support every aspect of your visual communication strategy
            </p>
            <Link to={'/price'}><button className='btn btn-price'>See Pricing Plans</button></Link>
          </div>
        </div>
      </div>
    </div>

    {/* Infographic design and admin assistant service */}
    <div className="assistance-services-section">
      <div className="container">
        <div className="row text-center mt-5">
          {/* Service Card 1 */}
          <div className="col-md-4">
            <div className="service-card">
              <div >
                <img src="/images/iStock.webp" className="graphic-placeholder" alt="" />
              </div>
              <h5 className="service-title mt-3">Social Media Design</h5>
              <p className="service-description">
              Boost your social media presence with our tailored social media design services. Our team creates eye-catching graphics that align with your brand and engage your audience. From posts to stories, we design content that enhances your social media strategy and drives interaction.
              </p>
            </div>
          </div>

          {/* Service Card 2 */}
          <div className="col-md-4">
            <div className="service-card">
              <div >
                <img src="/images/quality.webp" alt="" className="graphic-placeholder" />
              </div>
              <h5 className="service-title mt-3">Print Design</h5>
              <p className="service-description">
              Bring your brand to life with our high-quality print design services. We produce visually stunning materials, from brochures and flyers to posters and business cards. Our print designs are crafted to leave a lasting impression and effectively communicate your brand’s message.
              </p>
            </div>
          </div>

          {/* Service Card 3 */}
          <div className="col-md-4">
            <div className="service-card">
              <div >
                <img src="/images/one3.webp" alt="" className="graphic-placeholder" />
              </div>
              <h5 className="service-title mt-3">Infographic Design</h5>
              <p className="service-description">
              Elevate your information presentation with our expert infographic design services. We create visually compelling infographics that simplify complex data, making it easily digestible and highly engaging. Our designs are tailored to captivate your audience, ensuring your key messages are conveyed clearly and effectively. Transform your data into stunning visual narratives that stand out and make an impact.
              </p>
            </div>
          </div>
        </div>
        </div>
        </div>

        <PriceCard/>
        <ContactUs/>
        {/* <Footer/> */}

    </div>
  )
}

export default ConceptCretion